import React from "react";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";

import { ContractDetailTabText } from "./style";

const AwardedCompanyTab = () => {
  const {
    adminContractDetails: { awardedCompany = {} },
  } = useSelector((state) => state.admin);

  const details = [
    { title: "Company Name", value: awardedCompany.companyName || "N/A" },
    { title: "Business reg number", value: awardedCompany.registrationNumber || "N/A" },
    { title: "Business type/ Type of organization", value: awardedCompany.organizationType || "N/A" },
    { title: "Address", value: awardedCompany.address || "N/A" },
    { title: "Registration ID", value: awardedCompany.registerationID || "N/A" },

    { title: "Registration class", value: awardedCompany.registrationClass || "N/A" },
    { title: "Status", value: awardedCompany.status || "N/A" },
    { title: "Reason for award", value: awardedCompany.reasonForAward || "N/A" },
  ];

  return details.map((detail, i) => (
    <Grid key={i} style={{ borderBottom: "1px solid #CBD4DA" }} container>
      <Grid item xs={5}>
        <ContractDetailTabText>{detail.title}</ContractDetailTabText>
      </Grid>
      <Grid item sm style={{ borderLeft: "1px solid #CBD4DA" }}>
        <ContractDetailTabText>{detail.value}</ContractDetailTabText>
      </Grid>
    </Grid>
  ));
};

export default AwardedCompanyTab;
